import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

const apiScope = environment.apiScope;

export const authConfig: AuthConfig = {
  responseType: 'code',
  requireHttps: true,
  timeoutFactor: 0.9,
  strictDiscoveryDocumentValidation: false,
  showDebugInformation: true,
  clearHashAfterLogin: true,
  nonceStateSeparator: 'semicolon',
  scope: apiScope,
  oidc: true,
  skipIssuerCheck: false,
  disableAtHashCheck: true,
  skipSubjectCheck: true,
};

export function createAuthConfig(issuer: string, clientId: string): AuthConfig {
  return {
    ...authConfig,
    issuer,
    clientId,
  };
}
